import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useProductLineItem} from "../hooks/useProductLineItem.ts";
import {ProductLineItem} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required')
    }

    const {
        createRecord,
    } = useProductLineItem(productId);

    // No `id` and no `created`: the add form starts from the two fields it edits. The
    // product comes from the route, and the service whitelists the create input.
    return (
        <FormDrawer
            record={{
                productId: productId,
                productFeatureId: '',
                position: 0,
            } as ProductLineItem}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
